import { MouseEvent } from 'react';
import { useAnalytics } from 'edrolo/analytics';
import {
  Popover,
  usePopover,
  ClickAwayListener,
  enums,
  Pill,
  Icon,
  Heading,
  utils as u,
} from 'edrolo-ui';

import styles from './styles.scss';

interface PopoverContent {
  id: number;
  name: string;
}

interface PopoverPillProps {
  title: string;
  header?: string;
  items: PopoverContent[];
  iconName?: enums.Icons;
  iconColor?: enums.ColorTheme | enums.ColorHue;
  trackingTitle?: string;
}

export const PopoverPill = ({
  title,
  header,
  items,
  trackingTitle,
  iconName,
  iconColor = enums.ColorTheme.PRIMARY,
}: PopoverPillProps) => {
  const { isOpen, anchor, togglePopover, closePopover } = usePopover();

  const { track } = useAnalytics({});

  const handleSkillCoverageClick = (event: MouseEvent<HTMLElement>) => {
    track(`${trackingTitle} info tip clicked`);
    togglePopover(event);
  };

  return (
    <ClickAwayListener onClickAway={closePopover}>
      <div>
        <Pill
          variant={enums.PillVariant.OUTLINE}
          color={enums.ColorTheme.FOREGROUND}
        >
          {title}
          <button className={styles.button} onClick={handleSkillCoverageClick}>
            <Icon name={enums.Icons.INFO_TIP} />
          </button>
        </Pill>
        <Popover
          isOpen={isOpen}
          anchor={anchor}
          placement={enums.Placement.BOTTOM_END}
          closePopover={closePopover}
        >
          <div className={styles.content}>
            <Heading level={6} className={u.uppercase}>
              {header}:
            </Heading>
            <ul>
              {items.map((item) => (
                <li key={item.id}>
                  {iconName && <Icon name={iconName} color={iconColor} />}
                  {item.name}
                </li>
              ))}
            </ul>
          </div>
        </Popover>
      </div>
    </ClickAwayListener>
  );
};
